import api from 'Application/api/api';

const deleteTemplate = (id, cancelToken = null) =>
    api.delete(`project-manager/templates/${id}`, {
        cancelToken,
    });

export default deleteTemplate;
